import { BiExit, BiSupport } from "react-icons/bi";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { IoSettingsSharp } from "react-icons/io5";
import styled from "styled-components";
import * as React from "react";

interface Props {
  closeMenu: () => void;
  changeIdiom: (data: any) => void;
  store: any;
}

export default function Menu(props: Props) {
  const { store, closeMenu } = props;

  const [islogged, setIsLogged] = React.useState<boolean>(false);
  const [showIdioms, setShowIdioms] = React.useState<boolean>(false);

  React.useEffect(() => {
    setIsLogged(store.is_logged);
  }, []);

  const exitAccount = () => {
    const con = window.confirm(
      "Estas seguro que quieres salir de la cuenta🙉?"
    );

    if (con) {
      store.handledLogged(false);
      localStorage.clear();
      window.location.reload();
      setIsLogged(false);
    }
  };
  return (
    <Content id="contentmenu">
      <div className="modall">
        <ul>
          {islogged && (
            <>
              <li>
                <IoSettingsSharp /> Configurar cuenta
              </li>
              <li>
                <BiSupport /> Soporte
              </li>
              <li>
                <BsFillCheckCircleFill />
                Cambiar/mejorar plan🚀
              </li>
            </>
          )}
          {/* <p onClick={() => setShowIdioms(true)}>Cambiar idioma</p>
          {showIdioms && (
            <>
              <li onClick={() => props.changeIdiom("es")} className="px-4">
                Español
              </li>
              <li onClick={() => props.changeIdiom("en")} className="px-4">
                Ingles
              </li>
            </>
          )} */}
          {islogged && (
            <>
              <li onClick={() => exitAccount()}>
                <BiExit />
                Salir de la cuenta
              </li>
            </>
          )}
        </ul>
      </div>
      <div
        className="w-100 text-center py-3 contentClose"
        onClick={() => closeMenu()}
      >
        <span>Click para cerrar</span>
      </div>
    </Content>
  );
}

const Content = styled.div`
  position: fixed;
  top: 4.5em;
  left: 0;
  width: 100%;
  z-index: 20000;
  padding: 1em;
  height: 100vh;
  background: #0c0c0c21;
  overflow: hidden;
  .contentClose {
    height: 100vh;
    display: flex;
    justify-content: Center;
    align-items: center;
    color: white;
  }
  .modall {
    width: 100%;
    background: white;
    border-radius: 12px;
    padding: 1em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 20001;
    ul {
      list-style: none;
      font-size: 1.2em;
      font-weight: bold;
      margin: 0;
      li {
        padding: 0.4em 0;
      }
    }
    svg {
      margin: 0 0.2em;
    }
  }
  p {
    margin: 0 !important;
  }
`;
